module.exports = __webpack_public_path__ + "media/images/vp/icon.rightarrow2.white-992b10b8f0cf713c02e47bb9c3d0f059.svg";